import { Navigate, useOutlet } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

function OpenLayout(props) {
  const { user } = useAuth();
  const outlet = useOutlet();

  return (
    <>
      {
        user ? (
          <Navigate to="home" replace />
        ) : (
          <section>
            {outlet}
          </section>
        )        
      }      
    </>
  );
}

export default OpenLayout;
